import React from 'react';
import PageTransition from '../components/layout/PageTransition';
import Hero from '../components/sections/Hero';
import ServicesPreview from '../components/sections/ServicesPreview';
import WhyVoila from '../components/sections/WhyVoila';
import Process from '../components/sections/Process';
import Outcomes from '../components/sections/Outcomes';
import CTABanner from '../components/sections/CTABanner';

export default function HomePage() {
  return (
    <PageTransition>
      <Hero />
      <ServicesPreview />
      <WhyVoila />
      <Process />
      <Outcomes />
      <CTABanner />
    </PageTransition>
  );
}
